"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('register', {
            url: '/register',
            template: require('../views/register.html'),
            controller: 'RegisterController',
            controllerAs: 'register'
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/core/register/config/routes.js
// module id = 328
// module chunks = 0